module.exports = __webpack_public_path__ + "static/media/Gulf Bank_.55963147.jpg";